/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */
import { map } from "lodash";
import { SingleDocument, Resource } from "../utils/json-api";
import { MailJetMessages, MailJetMessage } from "../types/MailJetMessages";
import { ApiService } from "../services/Api.service";

/**
 *
 */
export class MailApi {

    constructor(private api: ApiService) {
    }
    
    /**
     * 
     * @param from 
     * @param to 
     * @param subject 
     * @param htmlBody 
     * @param attachments 
     */
    public async send(from, to, subject, htmlBody, attachments = []) {
        const message: MailJetMessage = {
            "From": { "Email": "no-reply@www.simulateur-prevoyance.ag2rlamondiale.fr", "Name": "Ne pas répondre" },
            "ReplyTo": null,
            "To": [{ "Email": to.email, "Name": to.name }],
            "Subject": subject,
            "HTMLPart": htmlBody,
            "Attachments": map(attachments, (attachment) => {
                return {
                    "ContentType": "text/plain",
                    "Filename": attachment.filename,
                    "Base64Content": attachment.base64Content
                };
            })
        };
        const reqDoc = new SingleDocument<MailJetMessages>().setResource(new Resource("Messages", { Messages: [message] }));
        const response = await this.api.post<MailJetMessages>("/quotations/send-email", reqDoc);
        return response.asSingleDocument();
    }
        
}



// WEBPACK FOOTER //
// ./src/api/Mail.api.ts